import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useNavigate, Link } from 'react-router-dom';
import { ArrowLeft } from 'lucide-react';
import { Button } from '../components/ui/button';
import { toast } from 'sonner';
import api from '../utils/api';
import LanguageSwitcher from '../components/LanguageSwitcher';
import Logo from '../components/Logo';
import QRForm from '../components/QRForm';

const CreateQRPage = () => {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const [loading, setLoading] = useState(false);

  const handleSubmit = async (formData) => {
    setLoading(true);
    try {
      await api.post('/qr/create', formData);
      toast.success(t('qr_created'));
      navigate('/dashboard');
    } catch (error) {
      toast.error(error.response?.data?.detail || t('error_occurred'));
      throw error;
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen bg-gradient-to-br from-white via-primary-50 to-white">
      <header className="sticky top-0 z-50 bg-white/70 backdrop-blur-xl border-b border-white/20 shadow-sm">
        <div className="container mx-auto px-6 md:px-12 py-4 flex justify-between items-center">
          <div className="flex items-center gap-4">
            <Link to="/dashboard" data-testid="back-to-dashboard-btn">
              <Button variant="ghost" size="sm">
                <ArrowLeft className="h-4 w-4 mr-2" />
                {t('back')}
              </Button>
            </Link>
            <div className="flex items-center gap-2">
              <Logo className="h-8 w-8" />
              <span className="text-2xl font-heading font-bold text-primary">cyQRus</span>
            </div>
          </div>
          <LanguageSwitcher />
        </div>
      </header>

      <main className="container mx-auto px-6 md:px-12 py-8 max-w-4xl">
        <h1 className="text-3xl sm:text-4xl font-heading font-bold text-primary mb-8" data-testid="create-qr-title">{t('create_qr')}</h1>
        <QRForm onSubmit={handleSubmit} loading={loading} />
      </main>
    </div>
  );
};

export default CreateQRPage;